// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-select:disabled {\n  color: #495057;\n  opacity: 1;\n}\n\n.custom-select-sm {\n  padding-top: 0px;\n  padding-bottom: 0px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
